
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CoreService {
  constructor(private http: HttpClient) {}

  getBrowserLocale(): Observable<string> {
    return this.http.get('apiurl://languageheader').pipe(map((header: string) => {
      let code = 'en';
      if (header) {
        code = header.split(',')[0];
        if (~code.indexOf('-') && !code.startsWith('zh')) {
          code = code.split('-')[0];
        } else if (code.startsWith('zh')) {
          code = code;
        }
      }
      return code;
    }));
  }
}


/*
lblMyLCIMyLionWebMyLionApp
lblTheseWillBeYour
lblMemberIDWeb
lblMonth
lblDay
lblYear
lblPhoneNumber
lblConfirmyourPassword
btnContinue
msgTherehasbeenanerror
 */
